import axios from 'axios'
import anime from 'animejs'
import { get } from '@bigyouth/base'

import withScroll from '../hoc/withScroll'
import { Cart } from '../utils/cart'
import emitter from '../utils/emitter'

import { DISPO_MODAL_ACTIONS } from './dispoModal'

export default withScroll({
  name: 'add-to-cart',

  isDesktop: window.innerWidth > 992,
  isButtonsDisabled: true,

  options: {
    localesKey: 'addToBagForm',
    endpointChange: '/cart/change.js',
    endpointAdd: '/cart/add.js',
    method: 'POST',
  },

  ui: {
    'addButtons[]': '[js-add-to-cart-button]',
    wrapperAvailable: '[js-add-to-cart-available]',
    wrapperUnavailable: '[js-add-to-cart-unavailable]',
    'dispoModalButtons[]': '[js-add-to-cart-dispo-modal-button]',
    'limitTooltips[]': '[js-add-to-cart-tooltip-limit]',
    'errorTooltips[]': '[js-add-to-cart-tooltip-error]',
    'sizesButtons[]': '[js-add-to-cart-size]',
  },

  events: [
    {
      on: 'click',
      target: 'sizesButtons',
      handle ({ target }) {
        this.handleSizeSelectChange(target)
      },
    },
    {
      on: 'click',
      target: 'addButtons',
      handle (e) {
        e.preventDefault()

        const productId = this.getProductId()

        if (productId !== '') {
          // first we get cart data
          axios.get('/cart.js')
            .then(res => {
              this.updateStock(productId, res.data)
            })
            .catch(this.handleError.bind(this))
        }
      },
    },
    {
      on: 'click',
      target: 'dispoModalButtons',
      handle () {
        const productSku = this.getProductSku()
        if (productSku === 'undefined') {
          alert('undefined')
        }
        if (productSku !== '') {
          emitter.trigger(DISPO_MODAL_ACTIONS.OPEN, { productSku })
        }
      },
    },
  ],

  componentDidMount () {
    // Move disponibility modal to modals layer
    const modalsLayer = get('.modals')
    this.modal = get('[js-add-to-cart-dispo-modal]')
    modalsLayer.appendChild(this.modal)

    if (this.props.isSingleSize) {
      const isAvailable = this.props.singleVariantAvailable

      // Hide add buttons if no stock is available for single size product
      if (!isAvailable) {
        this.ui.wrapperAvailable.hidden = true
        this.ui.wrapperUnavailable.hidden = false
      }
    } else if (!this.getProductId()) {
      // Disabled add buttons if a size isn't selected
      this.ui.addButtons.forEach((addButton) => {
        addButton.disabled = true
      })
    }
  },

  updateStock (productId, cartData) {
    let actualQuantity = 0

    cartData.items.forEach((item) => {
      if (item.id === parseInt(productId)) {
        actualQuantity = item.quantity
      }
    })

    const quantityToSet = actualQuantity + 1

    axios({
      url: actualQuantity > 0 ? this.options.endpointChange : this.options.endpointAdd,
      method: this.options.method,
      data: {
        id: productId,
        quantity: quantityToSet,
      },
    })
      .then((res) => {
        let newQuantity = 0

        // when we add a product, response is different
        if (actualQuantity > 0) {
          res.data.items.forEach((item) => {
            if (item.id === parseInt(productId)) {
              newQuantity = item.quantity
            }
          })
        } else {
          newQuantity = res.data.quantity
        }

        if (newQuantity !== quantityToSet) {
          this.ui.limitTooltips.forEach((tooltip) => {
            this.showToolTip(tooltip)
          })
        } else {
          Cart.reloadMiniCart()
          emitter.trigger('cart_update')
        }
      })
      .catch(this.handleError.bind(this))
  },

  handleError () {
    this.ui.errorTooltips.forEach((tooltip) => {
      this.showToolTip(tooltip)
    })
  },

  handleSizeSelectChange (target) {
    const current = get('[js-add-to-cart-size].is-active')
    const isAvailable = target.dataset.available === 'true'

    if (current) {
      current.classList.remove('is-active')
    }

    target.classList.add('is-active')

    if (isAvailable) {
      this.ui.wrapperAvailable.hidden = false
      this.ui.wrapperUnavailable.hidden = true

      this.ui.addButtons.forEach((addButton) => {
        addButton.disabled = false
      })
    } else {
      this.ui.wrapperAvailable.hidden = true
      this.ui.wrapperUnavailable.hidden = false

      this.ui.addButtons.forEach((addButton) => {
        addButton.disabled = true
      })
    }
  },

  showToolTip (target) {
    // if (this.tooltipAnim) {
    //   this.tooltipAnim.seek(this.tooltipAnim.duration)
    // }

    this.tooltipAnim = anime.timeline()
      .add({
        targets: target,
        opacity: 0,
        translateY: '15px',
        scaleY: 1.1,
        duration: 0,
      })
      .add({
        targets: target,
        opacity: 1,
        translateY: 0,
        scaleY: 1,
        duration: 800,
        easing: 'easeOutExpo',
      })
      .add({
        targets: target,
        opacity: 0,
        translateY: '-20px',
        scaleY: 1.1,
        duration: 600,
        delay: 2500,
        easing: 'easeInCubic',
      })
  },

  getProductId () {
    if (this.props.isSingleSize) {
      return this.props.singleVariantId
    } else {
      let selectedProduct = get('[js-add-to-cart-size].is-active')
      let id = false

      if (selectedProduct) {
        id = selectedProduct.dataset.value
      }
      return id
    }
  },

  getProductSku () {
    if (this.props.isSingleSize) {
      return this.props.singleSku
    } else {
      let selectedProduct = get('[js-add-to-cart-size].is-active').dataset.sku || ''
      return selectedProduct
    }
  },

  onScroll ({ y }) {
    if (window.innerWidth < 768) {
      if (y + window.innerHeight >= get('.footer').offsetTop) {
        this.el.classList.add('is-hidden')
      } else {
        this.el.classList.remove('is-hidden')
      }
    }
  },
})
